/* About page chrome - menu, sheets, counts, reveal, reviews slider */
(() => {
  const shop = {
    cart: JSON.parse(localStorage.getItem("mana_cart") || "[]"),
    wish: JSON.parse(localStorage.getItem("mana_wish") || "[]"),
    compare: JSON.parse(localStorage.getItem("mana_compare") || "[]")
  };
  const productMap = new Map(Object.entries(JSON.parse(localStorage.getItem("mana_products") || "{}")));

  function money(n) {
    return `Rs.${Number(n).toLocaleString("en-PK")}`;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function findProduct(id) {
    return productMap.get(id) || null;
  }

  function cartCount() {
    return shop.cart.reduce((n, i) => n + (i.qty || 1), 0);
  }

  function paintCounts() {
    const map = { wish: shop.wish.length, compare: shop.compare.length, cart: cartCount() };
    document.querySelectorAll("[data-count]").forEach((el) => {
      const n = map[el.dataset.count] || 0;
      el.textContent = n || "";
      el.dataset.empty = n ? "false" : "true";
    });
    document.querySelector('.icons [data-open="wish"]')?.classList.toggle("is-visible", shop.wish.length > 0);
  }

  function renderWish() {
    const box = document.querySelector('[data-list="wish"]');
    if (!box) return;
    const rows = shop.wish.map((id) => findProduct(id)).filter(Boolean);
    box.innerHTML = rows.length
      ? rows.map((p) => `<div class="sheet-row">
          <img src="${p.img || ""}" alt="">
          <div><strong>${escapeHtml(p.title)}</strong><span>${p.price || ""}</span></div>
        </div>`).join("")
      : "<p>No saved pieces yet.</p>";
  }

  function renderCart() {
    const box = document.querySelector('[data-list="cart"]');
    const foot = document.querySelector("[data-cart-foot]");
    if (!box) return;
    const rows = shop.cart.map((item) => ({ item, p: findProduct(item.id) })).filter((r) => r.p);
    if (!rows.length) {
      box.innerHTML = "<p>Your cart is empty.</p>";
      if (foot) foot.innerHTML = "";
      return;
    }
    box.innerHTML = rows.map(({ item, p }) => `<div class="sheet-row">
      <img src="${p.img || ""}" alt="">
      <div><strong>${escapeHtml(p.title)}</strong><span>${p.price} · Qty ${item.qty}</span></div>
    </div>`).join("");
    const total = rows.reduce((n, { item, p }) => n + (p.amount || 0) * item.qty, 0);
    if (foot) {
      const wa = "I would like to order. Total " + money(total) + ".";
      foot.innerHTML = (typeof window.manaCartFootHTML === "function")
        ? window.manaCartFootHTML("Total " + money(total), wa)
        : `<div>Total ${money(total)}</div><div class="sheet__actions"><button type="button" class="btn btn-dark" data-checkout>Checkout</button><a class="btn btn-gold" href="https://wa.me/923114711112?text=${encodeURIComponent(wa)}">Order on WhatsApp</a></div>`;
    }
  }

  function renderCompare() {
    const box = document.querySelector('[data-list="compare"]');
    if (!box) return;
    const rows = shop.compare.map((id) => findProduct(id)).filter(Boolean);
    box.innerHTML = rows.length
      ? rows.map((p) => `<div class="sheet-row">
          <img src="${p.img || ""}" alt="">
          <div><strong>${escapeHtml(p.title)}</strong><span>${p.price || ""}</span></div>
          <a class="btn btn-dark" href="${p.url || "/collections/all"}">View</a>
        </div>`).join("")
      : "<p>Add products to compare from the shop.</p>";
  }

  function openSheet(name) {
    document.querySelectorAll(".sheet").forEach((el) => { el.hidden = true; });
    const sheet = document.getElementById(`sheet-${name}`);
    if (!sheet) return;
    if (name === "wish") renderWish();
    if (name === "cart") renderCart();
    if (name === "compare") renderCompare();
    sheet.hidden = false;
  }

  function closeSheets() {
    document.querySelectorAll(".sheet").forEach((el) => { el.hidden = true; });
  }

  const menuBtn = document.querySelector("[data-menu]");
  const nav = document.querySelector("[data-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.querySelectorAll("[data-open]").forEach((btn) => {
    btn.addEventListener("click", () => openSheet(btn.dataset.open));
  });
  document.querySelectorAll("[data-close]").forEach((btn) => {
    btn.addEventListener("click", closeSheets);
  });
  document.querySelectorAll(".sheet").forEach((sheet) => {
    sheet.addEventListener("click", (e) => {
      if (e.target === sheet) closeSheets();
    });
  });

  const search = document.getElementById("search");
  document.querySelector("[data-open-search]")?.addEventListener("click", () => {
    if (!search) return;
    search.hidden = false;
    search.querySelector("input")?.focus();
  });
  document.querySelector("[data-close-search]")?.addEventListener("click", () => {
    if (search) search.hidden = true;
  });
  search?.addEventListener("click", (e) => {
    if (e.target === search) search.hidden = true;
  });

  paintCounts();

  const reveals = document.querySelectorAll(".about-reveal");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-in"));
  }

  /* -- Google reviews slider (60+) -- */
  const AVATARS = ["#e57373", "#64b5f6", "#81c784", "#ba68c8", "#ffb74d", "#4db6ac", "#f06292", "#7986cb", "#a1887f", "#90a4ae", "#ff8a65", "#4dd0e1"];
  const NAMES = [
    "Ayesha Rauf", "Hassan Malik", "Sana Khalid", "Farah Naveed", "Umer Siddiqui", "Mehwish Ali",
    "Bilal Ahmed", "Hira Khan", "Zainab Noor", "Ali Raza", "Nadia Sheikh", "Imran Qureshi",
    "Saima Bashir", "Omar Farooq", "Rabia Tariq", "Fahad Iqbal", "Maham Zafar", "Asad Mehmood",
    "Kiran Shah", "Taimoor Ali", "Nimra Hassan", "Shahid Anwar", "Amina Javed", "Danish Butt",
    "Laiba Saeed", "Hamza Yousaf", "Sadia Rehman", "Waqas Mir", "Iqra Nadeem", "Rizwan Haider",
    "Mariam Akhtar", "Saad Chaudhry", "Hafsa Gul", "Junaid Aslam", "Bushra Fatima", "Adeel Nawaz",
    "Eman Zahra", "Kashif Latif", "Noor Fatima", "Usman Ghani", "Areeba Malik", "Shahzad Khan",
    "Zoya Imtiaz", "Haris Noman", "Aqsa Bibi", "Muneeb Rauf", "Saba Parveen", "Faisal Aziz",
    "Hania Amir", "Arslan Jutt", "Mahnoor Rizvi", "Nabeel Shah", "Anaya Qadir", "Taha Kamran",
    "Sara Lodhi", "Yasir Pasha", "Dua Fatima", "Kamran Ghani", "Iman Sohail", "Rameez Khan",
    "Aleena Bukhari", "Shayan Malik", "Hadiqa Noor", "Moiz Ahmed"
  ];
  const TEXTS = [
    "Ordered a 72-piece dinner set from their website for my new flat in DHA Phase 5. Got same-day delivery which honestly surprised me. Packaging was thick and nothing was chipped. The plates look even nicer in real life than in the photos.",
    "Went to the Ichra branch with my wife to pick a tea set for her mother’s birthday. Staff showed us 4–5 options without any pushy selling. Quality of the bone china is solid for the price. Parking nearby is a bit tight but the store itself is well stocked.",
    "Ordered a Turkish crockery set as a wedding gift and had it delivered to Islamabad. WhatsApp team replied fast about stock and delivery timeline. One cup had a tiny mark so they replaced it without drama.",
    "Visited the DHA Phase 1 showroom on Khayaban-e-Jinnah. Beautiful display of candle stands, dinnerware and décor. Bought a platter set and two planters. Prices are fair compared to other DHA shops.",
    "Old customer of their Shah Alam market shop. Family business feel, they remember returning clients. Bought cutlery + hotpot set before Ramadan. COD worked smoothly for the online order I placed for my sister in Karachi.",
    "Nice range of mugs and glasses. I wanted a specific colour that was out of stock at DHA so they checked Ichra and held it for me. Service is genuine.",
    "Bought a full dinner set for our new home in Bahria Town. Delivery came next day and everything was packed with foam sheets. Highly recommend Manna Crockery.",
    "Came for planters and left with wall clocks and a vase too. Staff at Shah Alam were patient while we compared finishes. Good prices for the quality.",
    "WhatsApp ordering is so easy. Sent photos of what I wanted, they confirmed stock, and COD arrived in 2 days to Rawalpindi. Will shop again.",
    "Tea set quality is excellent - microwave safe pieces as labelled. Gift-wrapped on request for Eid. Small wait at the counter on weekend but worth it.",
    "Compared three glassware brands in-store. Manna’s range felt more premium without the crazy markup you see in malls. Took a 12-piece tumbler set.",
    "Bedding collection surprised me - velvet bedsheets look rich and stitching is neat. Delivered to Gulberg without damage.",
    "Second purchase from them. First was crockery last year, now décor for the lounge. Consistent quality and polite replies on chat.",
    "Went to Ichra specifically for Turkish crockery. Lots of options, clear prices, no hidden charges. Paid by card.",
    "Kids broke two plates; rematch order arrived quickly. Appreciate that they keep spare pieces for popular sets.",
    "Showroom in DHA is clean and well lit. Tried holding plates in hand before buying - weight and glaze feel solid.",
    "Ordered online during a sale. Discount applied correctly and tracking updates came on WhatsApp. Smooth experience.",
    "Bought buffet dishes for a family dawat. Looked elegant on the table and cleaned easily after. Guests asked where we got them.",
    "Staff helped me find a matching gravy boat for an older dinner set. Took 10 minutes and they found it. That’s rare these days.",
    "Candle stands from the décor section are beautiful. Photos on Instagram match what you get in store.",
    "Slight delay on intercity delivery to Multan (4 days) but packaging was perfect and product quality 5 stars.",
    "Husband surprised me with a bone china tea set from Manna. Box presentation was gift-ready. Love the floral pattern.",
    "Parking at Shah Alam can be hectic but once inside, selection is huge. Worth the trip if you are furnishing a home.",
    "Hotpot set works great on the stove. Handles stay comfortable. Ordered extras for my sister after trying ours.",
    "Return policy is clear - we exchanged a wrong size platter with no hassle at DHA branch. Thank you team.",
    "Looking for affordable yet classy crockery for rental flat. Found good mid-range sets without looking cheap.",
    "Their Instagram reels helped me decide colours. Then bought in-store. Seamless from social to shop floor.",
    "Cutlery set weight is nice - not flimsy. Mirror finish still looks good after weeks of use.",
    "Bought tissue boxes and a candy jar as housewarming gifts. Recipients loved them. Will gift from here again.",
    "Customer care remembered my previous order when I called. Personal touch you don’t get from big chains.",
    "Platters are oven-safe as mentioned. Used them for baked pasta - no cracking. Very happy.",
    "Came from Faisalabad just for shopping here. Loaded the car with dinnerware and décor. Worth the drive.",
    "Website photos are accurate. What I ordered is exactly what arrived. Rare for online crockery shops.",
    "Kids’ mug set with cute prints - durable enough for daily use. Spill-proof lids were a bonus.",
    "Ramadan deal on glasses was fair. Packed carefully. Only wish they had more gift bags in stock that day.",
    "DHA staff explained care instructions without rushing. Felt informed before spending on a premium set.",
    "Ordered planters for the balcony. Heavy ceramic, good drainage holes. Look stylish with simple plants.",
    "Fourth time buying from Manna. Consistency is why I keep coming back - quality and honesty on stock.",
    "Wall clock from décor section keeps time well and looks expensive. Guests always notice it.",
    "Had a cracked plate in the box; they couriered a replacement free within a week. Good after-sales.",
    "Ice cream set is adorable for summer. Kids fight over who gets which bowl. Fun and practical.",
    "Compared with another Lahore brand - Manna won on glaze and plate weight. Paid a bit more, no regrets.",
    "Easy returns if sealed. Returned a duplicate gift and got store credit quickly at Ichra.",
    "Buffet dishes kept food warm longer than our old steel trays. Perfect for large family dinners.",
    "Phone support on 0322 number answered in Urdu and English. Clear about delivery slots for DHA.",
    "Bought suitcase-style picnic crockery on impulse. Surprisingly useful for trips. Nice find.",
    "Decor flowers and statue pieces look high-end. Matched our lounge palette perfectly.",
    "Glass dinner set is microwave safe - tested already. Shine hasn’t faded after dishwasher cycles.",
    "Wedding registry shopping here was stress-free. Staff noted our list and we collected later.",
    "Bathroom set looks premium in our guest washroom. Matched chrome fittings nicely.",
    "Price tags are clear, no bargaining drama. Prefer that honest approach.",
    "Online checkout + COD for Gujranwala worked. Driver was polite and waited while we checked boxes.",
    "Got a complimentary care cloth with the dinner set. Small touch but appreciated.",
    "Vases are sturdy - not tippy. Used for fresh roses and artificial stems both look good.",
    "They held an item on WhatsApp until we reached the store after work. Very accommodating.",
    "Suitable for gifting corporate clients too - packaging looks professional.",
    "Painted serving bowls are unique. Haven’t seen the same design elsewhere in Lahore.",
    "Queue on Sunday afternoon but moved fast. Multiple counters help.",
    "Bought matching cups & saucers to complete an old set. Colour match was almost perfect.",
    "Electronics section had a good blender deal; bundled with kitchen accessories. One-stop shop vibe.",
    "After-sales WhatsApp reply within minutes at 10pm when I had a packing question. Impressed.",
    "Floor display in DHA makes it easy to visualise table settings. Helped us pick faster.",
    "No pressure to buy the most expensive set. They suggested mid-range that fit our budget.",
    "Sisters and I each bought different tea sets. All arrived undamaged to three different cities."
  ];
  const WHEN = [
    "2 days ago", "5 days ago", "a week ago", "2 weeks ago", "3 weeks ago", "a month ago",
    "2 months ago", "3 months ago", "4 months ago", "5 months ago", "6 months ago", "8 months ago",
    "10 months ago", "a year ago"
  ];

  function starsHtml(rating) {
    let out = "";
    for (let i = 1; i <= 5; i += 1) {
      const empty = i > rating ? ' class="is-empty"' : "";
      out += `<svg${empty} viewBox="0 0 24 24" aria-hidden="true"><path d="M12 17.3 18.2 21l-1.6-7.1L22 9.2l-7.2-.6L12 2 9.2 8.6 2 9.2l5.4 4.7L5.8 21z"/></svg>`;
    }
    return out;
  }

  function buildReviews() {
    const list = [];
    for (let i = 0; i < 64; i += 1) {
      const name = NAMES[i % NAMES.length];
      const rating = i % 11 === 0 || i % 17 === 0 ? 4 : 5;
      const reviewsCount = 3 + ((i * 7) % 120);
      const photos = i % 3 === 0 ? ` · ${1 + (i % 40)} photos` : "";
      const local = i % 4 === 0 ? "Local Guide · " : "";
      const liked = i % 3 !== 1;
      const helpful = 2 + ((i * 5) % 36);
      list.push({
        name,
        initial: name.charAt(0),
        color: AVATARS[i % AVATARS.length],
        meta: `${local}${reviewsCount} reviews${photos}`,
        rating,
        when: WHEN[i % WHEN.length],
        text: TEXTS[i % TEXTS.length],
        helpful: liked
          ? `Liked by owner · ${helpful} people found this helpful`
          : `${helpful} people found this helpful`
      });
    }
    return list;
  }

  function reviewCard(r) {
    return `<article class="g-review">
      <header class="g-review__head">
        <span class="g-review__avatar" style="--g-av:${r.color}" aria-hidden="true">${escapeHtml(r.initial)}</span>
        <div class="g-review__who">
          <strong>${escapeHtml(r.name)}</strong>
          <span>${escapeHtml(r.meta)}</span>
        </div>
      </header>
      <div class="g-review__meta">
        <div class="g-reviews__stars g-reviews__stars--sm" role="img" aria-label="${r.rating} out of 5 stars">${starsHtml(r.rating)}</div>
        <time>${escapeHtml(r.when)}</time>
      </div>
      <p class="g-review__text">${escapeHtml(r.text)}</p>
      <p class="g-review__helpful">${escapeHtml(r.helpful)}</p>
    </article>`;
  }

  function initReviewsSlider() {
    const track = document.querySelector("[data-reviews-track]");
    const viewport = document.querySelector(".g-reviews__viewport");
    const prev = document.querySelector("[data-reviews-prev]");
    const next = document.querySelector("[data-reviews-next]");
    const countEl = document.querySelector("[data-reviews-count]");
    if (!track || !viewport) return;

    const reviews = buildReviews();
    if (countEl) countEl.textContent = `${reviews.length}+ Google reviews`;
    track.innerHTML = reviews.map(reviewCard).join("");

    function step() {
      const card = track.querySelector(".g-review");
      if (!card) return 320;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function go(dir) {
      viewport.scrollBy({ left: dir * step(), behavior: "smooth" });
    }

    prev?.addEventListener("click", () => go(-1));
    next?.addEventListener("click", () => go(1));

    let timer = window.setInterval(() => go(1), 4500);
    const pause = () => { clearInterval(timer); timer = 0; };
    const resume = () => {
      if (timer) return;
      timer = window.setInterval(() => go(1), 4500);
    };
    viewport.addEventListener("pointerenter", pause);
    viewport.addEventListener("pointerleave", resume);
    viewport.addEventListener("touchstart", pause, { passive: true });
    prev?.addEventListener("click", () => { pause(); window.setTimeout(resume, 8000); });
    next?.addEventListener("click", () => { pause(); window.setTimeout(resume, 8000); });

    // Loop: when near end, jump back softly
    viewport.addEventListener("scroll", () => {
      const max = viewport.scrollWidth - viewport.clientWidth - 8;
      if (viewport.scrollLeft >= max) {
        window.setTimeout(() => {
          if (viewport.scrollLeft >= max) viewport.scrollTo({ left: 0, behavior: "smooth" });
        }, 600);
      }
    }, { passive: true });
  }

  initReviewsSlider();
})();
